import React from 'react'
import { Form, Input, Space } from 'antd'
import { DataItem, ErrorNotification, GraviButton, NotificationMessage, Texto } from '@gravitate-js/excalibrr'
import { MailOutlined } from '@ant-design/icons'
import api from '@utils/api'
import { useUsers } from '@api/useUsers'
export const PWModalContent = ({ driver, setViewingPWModal }) => {
  const { updateDriverPWMutation } = useUsers()
  const submitPW = (formData) => {
    const payload = {
      username: driver.username,
      new_password: formData.password,
    }

    try {
      updateDriverPWMutation.mutate(payload)
      NotificationMessage('Driver Password Changed', 'Driver Password was changed successfully.', false)
      setViewingPWModal(false)
    } catch {
      NotificationMessage('Incorrect Password', 'The password you supplied was incorrect.')
    }
  }
  return (
    <>
      <div className='mb-5 flex items-center ml-3' data-cy='driver-username'>
        <Space>
          <MailOutlined className='mt-2 pr-2 mail-icon' />
          <DataItem label='Driver Username'>
            <b>{driver.username}</b>
          </DataItem>
        </Space>
      </div>
      <Form
        onFinish={submitPW}
        onFinishFailed={ErrorNotification}
        className='pw-form'
        wrapperCol={{ span: 16 }}
        labelCol={{ span: 6 }}
      >
        <Texto className='mb-2' appearance='medium' category='label' weight='bold'>
          New Password
        </Texto>
        <Form.Item
          name='password'
          rules={[
            {
              required: true,
              message: 'Please input the new password.',
            },
          ]}
          hasFeedback
        >
          <Input.Password placeholder='New Password' />
        </Form.Item>
        <Texto className='mb-2' appearance='medium' category='label' weight='bold'>
          Confirm Password
        </Texto>
        <Form.Item
          name='confirm'
          dependencies={['password']}
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Please confirm the new password.',
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve()
                }
                return Promise.reject(new Error('The two passwords that you entered do not match!'))
              },
            }),
          ]}
        >
          <Input.Password placeholder='Confirm Password' />
        </Form.Item>
        <GraviButton buttonText='Change Password' theme2 htmlType='submit' data-cy='save-driver-pw-btn' />
      </Form>
    </>
  )
}
